import Branch from 'components/Tables/DataEntry/Branch/Branches/Branch';
import ContractualInformation from 'components/Tables/DataEntry/ContractualInformation/ContractualInformation/ContractualInformation';
import Entity from 'components/Tables/DataEntry/Entity/Entity/Entity';
import EntityType from 'components/Tables/DataEntry/Entity/EntityType/EntityType';
import EntityMaintainingregistry from 'components/Tables/DataEntry/EntityMaintainingRegistry/EntityMaintainingRegistry';
import Function from 'components/Tables/DataEntry/Function/Functions/Function';
import ICTServices from 'components/Tables/DataEntry/ICTServices/ICTServices/ICTServices';
import CurrencyAndCosts from 'components/Tables/DataEntry/TPP/CurencyAndCosts/CurencyAndCosts';
import ThirdPartyServiceProvider from 'components/Tables/DataEntry/TPP/ThirdPartyServiceProvider/ThirdPartyServiceProvider';
import Data from 'components/Tables/DataManagement/Data/Data/Data';
import ICTSystem from 'components/Tables/DataManagement/ICTSystems/ICTSystems';
import { STEP_KEYS, Step } from 'store/ducks/Global/types';

export const getRegisterOfInformationSteps = (t: any): Step[] => [
  {
    key: STEP_KEYS.ENTITY_MAINTAINING_REGISTER,
    title: t('AREAS.ENTITY_MAINTAINING_REGISTER_OF_INFORMATION'),
    content: <EntityMaintainingregistry />,
  },
  {
    key: 'ENTITY',
    title: t('AREAS.ENTITY'),
    content: <Entity />,
  },
  // {
  //   key: 'ENTITY_TYPE',
  //   title: t('AREAS.ALLOCATE_LICENSED_ACTIVITY'),
  //   content: <EntityType />,
  // },
  {
    key: 'BRANCH',
    title: t('AREAS.BRANCH'),
    content: <Branch />,
  },
  {
    key: 'FUNCTION',
    title: t('AREAS.FUNCTION'),
    content: <Function />,
  },
  {
    key: 'ICT_SYSTEMS',
    title: t('AREAS.ICT_SYSTEMS'),
    content: <ICTSystem />,
  },
  {
    key: STEP_KEYS.DATA,
    title: t('AREAS.DATA'),
    content: <Data />,
  },
  {
    key: STEP_KEYS.ICT_PROVIDER,
    title: t('AREAS.ICT_THIRD_PARTY_SERVICE_PROVIDER'),
    content: <ThirdPartyServiceProvider />,
  },
  {
    key: STEP_KEYS.CURRENCY_AND_COSTS,
    title: t('AREAS.CURRENCY_AND_COSTS'),
    content: <CurrencyAndCosts />,
  },
  {
    key: STEP_KEYS.CONTRACTUAL_INFORMATION,
    title: t('AREAS.CONTRACTUAL_INFORMATION'),
    content: <ContractualInformation />,
  },
  {
    key: STEP_KEYS.ICT_SERVICE,
    title: t('AREAS.ICT_SERVICE'),
    content: <ICTServices />,
  },
];
